import React, { Component } from "react"
import { Button, message, Tooltip } from "antd"
import axios from "axios"
import F from "../../../Functions"

class DistanceAndTimezone extends Component {
    state = {
        loading: false,
        data: {
            distance: null,
            timezone: null,
            agency_address: null,
            bfile_address: null,
        }
    }

    componentDidMount() {
        this.loadData();
    }


    loadData = async () => {
        const { bfile } = this.props
        const { data } = this.state
        this.setState({ loading: true })
        const apiCall = await axios.put("/api/google_maps/get_bfile_timezone_by_bfile_id/" + bfile.id)
        this.getData(apiCall).then((response) => {
            if (response.data && response.data.success) {
                data["timezone"] = response.data.timezone_name;
            }
        }).catch((error) => {
            F.showAndHandleServerError(error);
        })

        const apiCall2 = await axios.put("/api/google_maps/get_distance_by_bfile_id/" + bfile.id)
        this.getData(apiCall2).then((response) => {
            if (response.data && response.data.success) {
                this.setState((prevState)=>{
                    return {
                        ...prevState,
                        data: {
                           ...prevState.data,
                            distance: response.data.distance_miles,
                            agency_address: response.data.agency_address,
                            bfile_address: response.data.bfile_address,
                        }
                    }
                })
            }
        }).catch((error) => {
            F.showAndHandleServerError(error);
        })
        this.setState({ data: data, loading: false });

    }
    getData = async (apiCall) => {
        // Create a timeout promise
        const timeout = new Promise((_, reject) =>
            setTimeout(() => reject(new Error("Request timed out")), 3000)
        );

        try {
            // Race the API call against the timeout
            const response = await Promise.race([apiCall, timeout]);
            return response; // Handle the response
        } catch (error) {
            return null; // Ignore response if timed out or error
        }
    }


    handleMapRedirection = () => {
        const { agency_address, bfile_address } = this.state.data;
        if (!agency_address || !bfile_address) {
            message.error("Please provide both agency and B File addresses.");
            return;
        } else {
            axios.get(`/api/google_maps/maps_link?origin=${encodeURIComponent(agency_address)}&destination=${encodeURIComponent(bfile_address)}`).then((response) => {
                if (response.data.success) {
                    const mapUrl = response.data.google_maps_url;
                    window.open(mapUrl, "_blank");
                }
            });
            return;
        }
    }
    render() {

        const { distance, timezone } = this.state.data;
        

        return (
            <div className="padding-bottom-25"
                style={{ paddingTop: "5px" }}
            >
                {distance !== null && <span className="text-11 ">
                    Distance:
                    <Button type="link" onClick={this.handleMapRedirection} className="text-11 text-color-miles padding-left-right">
                        <span className="underline-text">{distance}</span>
                    </Button>
                </span>}
                {timezone !== null && <span className="text-11 ">
                    <Tooltip placement="top" title={timezone}>
                        <span style={{
                            width: "90%",
                            verticalAlign: "middle",
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: 'inline-block'
                        }}>{timezone}</span>
                    </Tooltip>
                </span>}
            </div>

        );
    }
}

export default DistanceAndTimezone;


// WEBPACK FOOTER //
// ./src/scenes/LandingPage/components/DistanceAndTimezone.js